// extracted by mini-css-extract-plugin
module.exports = {"AboutBanner":"AboutBanner_AboutBanner__XKEtJ","wrapper":"AboutBanner_wrapper__gPpdY","button":"AboutBanner_button__dI21t"};